<template>
    <div  :class="selectedContactID == contact.contact_id ? `form-group green-input-box` : `form-group`">
        <v-subheader v-if="selectedContactID!=0">
          <img width="20" height="20" v-if="selectedContactID == contact.contact_id" :src="`static/icons/tick.svg`"/>
          <img width="20" height="20" v-if="selectedContactID !== contact.contact_id" :src="`static/icons/close-circle.svg`"/>
            &nbsp;{{selectedContactID == contact.contact_id ? $t('keep') : $t('remove')}}
        </v-subheader>
        <button
          v-else
          class="dt-button v1 s6"
          @click.stop="onSelectClick"
        >
            {{$t('select_as_main')}}
        
        </button>
     
        <!-- <v-divider></v-divider> -->
          <!-- <button
            class="dt-button v5 s6"
             @click.stop="onSelectClick"
          >
            {{$t('select_as_main')}}
          </button> -->
          <TextField
            class="m1"
            :id="'company_name'"
            v-bind="textFieldConfig"
            :placeholder="$t('company_name')"
            :value="contact.company_name"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />

         <TextField
            class="m1"
            :id="'company_legalname'"
            v-bind="textFieldConfig"
            :placeholder="$t('legal_name')"
            :value="contact.company_legalname"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          
          <TextField
            class="m1"
            :id="'last_name'"
            v-bind="textFieldConfig"
            :placeholder="$t('last_name')"
            :value="contact.last_name"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />

          <TextField
            class="m1"
            :id="'first_name'"
            v-bind="textFieldConfig"
            :placeholder="$t('first_name')"
            :value="contact.first_name"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <Dropdown
            class="dt-dropdown m2"
            :options="languagesTV"
            :selected="languagesTV.find(e => e.value == contact.language)"
            box
            :placeholder="$t('language')"
            @selectedChange="e => onDropdownChange('language', e)"
            :listHeight="150"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'address1'"
            v-bind="textFieldConfig"
            :placeholder="$t('address')"
            :value="contact.address1"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'address2'"
            v-bind="textFieldConfig"
            :placeholder="$t('address')"
            :value="contact.address2"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'postalcode'"
            v-bind="textFieldConfig"
            :placeholder="$t('postal_code')"
            :value="contact.postalcode"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'city'"
            v-bind="textFieldConfig"
            :placeholder="$t('city')"
            :value="contact.city"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'region'"
            v-bind="textFieldConfig"
            :placeholder="$t('region')"
            :value="contact.region"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <Dropdown
            class="dt-dropdown m2"
            :options="countriesTV"
            :selected="countriesTV.find(e => e.value == contact.country)"
            box
            :placeholder="$t('country')"
            @selectedChange="e => onDropdownChange('country', e)"
            :listHeight="150"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'phone1'"
            v-bind="textFieldConfig"
            :placeholder="$t('phone_1')"
            :value="contact.phone1"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'phone2'"
            v-bind="textFieldConfig"
            :placeholder="$t('phone_2')"
            :value="contact.phone2"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'fax1'"
            v-bind="textFieldConfig"
            :placeholder="$t('fax')"
            :value="contact.fax1"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'email1'"
            v-bind="textFieldConfig"
            :placeholder="$t('email_1')"
            :value="contact.email1"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'email2'"
            v-bind="textFieldConfig"
            :placeholder="$t('email_2')"
            :value="contact.email2"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'url1'"
            v-bind="textFieldConfig"
            :placeholder="$t('url_1')"
            :value="contact.url1"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'chat3'"
            v-bind="textFieldConfig"
            :placeholder="$t('skype_im')"
            :value="contact.chat3"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            :textarea="true"
            class="m1"
            :id="'notes'"
            :height="128"
            v-bind="textFieldConfig"
            :placeholder="$t('notes')"
            :value="contact.notes"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
          />
          <TextField
            class="m1"
            :id="'vat_no'"
            v-bind="textFieldConfig"
            :placeholder="$t('vat_id')"
            :value="contact.vat_no"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <Dropdown
            class="dt-dropdown m2"
            :options="currencyTV"
            :selected="currencyTV.find(e => e.value == contact.currency_id)"
            box
            :placeholder="$t('currency')"
            @selectedChange="e => onDropdownChange('currency_id', e)"
            :listHeight="150"
            :disabled="isDisabled"
          />
          <Dropdown
            class="dt-dropdown m2"
            :options="paymentMethodsTV"
            :selected="paymentMethodsTV.find(e => e.value == contact.invoice_payment_method_id)"
            box
            :placeholder="$t('payment_method')"
            @selectedChange="e => onDropdownChange('invoice_payment_method_id', e)"
            :listHeight="150"
            :disabled="isDisabled"
          />
          <Dropdown
            class="dt-dropdown m2"
            :options="paymentMethodsTV"
            :selected="paymentMethodsTV.find(e => e.value == contact.cost_payment_method_id)"
            box
             :placeholder="`${this.$t('cost')} ${this.$t('payment_method')}`"
            @selectedChange="e => onDropdownChange('cost_payment_method_id', e)"
            :listHeight="150"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'account_holder'"
            v-bind="textFieldConfig"
            :placeholder="$t('account_holder')"
            :value="contact.account_holder"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'account_no'"
            v-bind="textFieldConfig"
            :placeholder="$t('account_no')"
            :value="contact.account_no"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'iban'"
            v-bind="textFieldConfig"
            :placeholder="$t('iban')"
            :value="contact.iban"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'sortcode'"
            v-bind="textFieldConfig"
            :placeholder="$t('sortcode')"
            :value="contact.sortcode"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'swift'"
            v-bind="textFieldConfig"
            :placeholder="$t('bic_swift')"
            :value="contact.swift"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'bank_name'"
            v-bind="textFieldConfig"
            :placeholder="$t('bank_name')"
            :value="contact.bank_name"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'bank_address'"
            v-bind="textFieldConfig"
            :placeholder="$t('bank_address')"
            :value="contact.bank_address"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'cost_center'"
            v-bind="textFieldConfig"
            :placeholder="$t('cost_center')"
            :value="contact.cost_center"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <v-subheader>{{$t('outgoing_invoices_txt')}}</v-subheader>
          <TextField
            class="m1"
            :id="'invoice_due_days'"
            v-bind="textFieldConfig"
            :placeholder="$t('due_days')"
            :value="contact.invoice_due_days"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <DTCheckbox
             :class="'ml0'"
            :id="'invoice_end_of_month_flag'"
            :label="$t('end_of_month')"
            :checked="contact.invoice_end_of_month_flag"
            :h="'auto'"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'invoice_discount_percent'"
            v-bind="textFieldConfig"
            :placeholder="$t('discount_percent')"
            :value="contact.invoice_discount_percent"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'invoice_discount_days'"
            v-bind="textFieldConfig"
            :placeholder="$t('discount_days')"
            :value="contact.invoice_discount_days"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <v-subheader>{{$t('incoming_invoices_txt')}}</v-subheader>
          <TextField
            class="m1"
            :id="'cost_due_days'"
            v-bind="textFieldConfig"
            :placeholder="$t('due_days')"
            :value="contact.cost_due_days"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <DTCheckbox
            :class="'ml0'"
            :id="'invoice_end_of_month_flag'"
            :label="$t('end_of_month')"
            :checked="contact.cost_end_of_month_flag == '1'"
            :h="'auto'"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'cost_discount_percent'"
            v-bind="textFieldConfig"
            :placeholder="$t('discount_percent')"
            :value="contact.cost_discount_percent"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'cost_discount_days'"
            v-bind="textFieldConfig"
            :placeholder="$t('discount_days')"
            :value="contact.cost_discount_days"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'customer_no'"
            v-bind="textFieldConfig"
            :placeholder="$t('customer_no')"
            :value="contact.customer_no"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'creditor_no'"
            v-bind="textFieldConfig"
            :placeholder="$t('creditor_id')"
            :value="contact.creditor_no"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
          <TextField
            class="m1"
            :id="'debitor_no'"
            v-bind="textFieldConfig"
            :placeholder="$t('debitor_no')"
            :value="contact.debitor_no"
            @valuechanged="(name,value)=>onTextFieldValueChange(name,value)"
            :disabled="isDisabled"
          />
    </div>  

</template>

<script>

import { EventHooks } from "../../../../plugins/text-field";

import DTCheckbox from "../../../../plugins/checkbox/checkbox";
export default {
props: {

    contact:{
      type:Object
    },
    languagesTV:{
      type:Array
    },
    countriesTV:{
      type:Array
    },
    currencyTV:{
      type:Array
    },
    paymentMethodsTV:{
      type:Array
    },
    contactKey:{
      type:String
    },
    selectedContactID:{
      type:Number
    }
},
  components: {
    DTCheckbox
  },
  mounted:async function () {
  
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        valueChangedEvent: EventHooks.OnBlur
      },
    };
  },

  watch: {},
  computed: {
    isDisabled:function(){
        return this.selectedContactID==this.contact.contact_id ? false:true;
    }
  },
  methods: {
    onTextFieldValueChange: function (name,value) {    
        
        this.$emit('change',{name,value,key:this.contactKey})

        //   console.log(name,value,key)
        //   this[key][name] = value
    
    },
    onDropdownChange:function( name , e){

      this.$emit('change',{name,value:e.value,key:this.contactKey})
      console.log(name,e.value)
    },
    onSelectClick:function(){
        this.$emit('selectClick',this.contact.contact_id)
    }

  },
};
</script>

<style lang="scss">
.cmp-contacts-import_export-merge_contact {
  .contact-type-selection {
    .contact-type:first-child {
      margin-top: 0px;
    }
    .contact-type:last-child {
      margin-bottom: 0px;
    }
    margin-bottom: 30px;
  }
  .subheader{
    padding: 0px;
  }
}

// .search {
//   padding: 10px 0 10px 10px !important;
// }
// .cb-filters {
//   padding: 5px 10px !important;
// }
// .cb-flex {
//   padding-top: 5px;
// }

// .checkbox-container {
//   padding: 5px 0;
// }

// .form-group .dt-dropdown {
//   margin: 5px 5px !important;
// }

// .contacts {
//   .contact-item {
//     padding: 5px;

//     .checkbox-container {
//       padding: 5px 0px;
//     }

//     &:nth-child(even) {
//       background: var(--sprt-8);
//     }
//     .contact-name {
//       cursor: pointer;
//     }
//   }
// }
</style>
